module.exports = __webpack_public_path__ + "static/img/game-bg.39158f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/game-bg.jpg
// module id = vPrr
// module chunks = 1